import React from "react";

export const CatalogTabIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9533_42790)">
        <circle
          cx="14.5042"
          cy="8.50416"
          r="5.49618"
          transform="rotate(-29.8939 14.5042 8.50416)"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M17.2432 13.2686L20.8955 19.6218"
          stroke="black"
          strokeWidth="1.5"
        />
        <line
          x1="2"
          y1="8.25"
          x2="6"
          y2="8.25"
          stroke="black"
          strokeWidth="1.5"
        />
        <path d="M2 13.25H8" stroke="black" strokeWidth="1.5" />
        <path d="M2 18.25H12.5" stroke="black" strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_9533_42790">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
